export default __webpack_public_path__ + "static/media/08_ojczyzna.0f1d8371.png";